import React, { useEffect } from 'react';
import { Redirect } from 'expo-router';

// Apenas redireciona para a rota já existente no aplicativo
export default function OrderingRedirect() {
  // O componente Redirect já cuida da navegação imediata
  return <Redirect href="/(app)/field-ordering" />;
} 